
export class Config {
    public enableConsoleLog = true;
    public channel = "Web";

    public msisdnURL = "http://header.safaricombeats.co.ke/";
}